import React from 'react';

import './index.scss';

//material-ui
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

//custom components

//api
// import {api} from '../../../../functions/api'

//other libraries
import { inject, observer } from 'mobx-react';
import Dropzone from 'react-dropzone'

@inject('internal')
@inject('translate')
@observer
export default class ImportClients extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            file: null,
            extension: null
        }
    }

    handleDrop = (files) => {
        if(files[0] !== undefined) {
            let fileNameArr = files[0].name.split('.');

            let extension = fileNameArr[fileNameArr.length - 1]
            if(extension === "xls" || extension === "xlsx") {
                this.setState({
                    file: files[0],
                    extension: extension,
                })
            }
        }
        else {
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.FORMAT_IS_NOT_VALID, true)
        }
        
    }

    handleImport = async() => {
    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.onClose}
                
            >
                <DialogContent className={'import-clients-dialog'}>
                <DialogTitle className={'title'}>{this.props.title}</DialogTitle>
                <Dropzone
                    onDrop={files => this.handleDrop(files)}
                    // disableClick
                    multiple={false}
                    accept={[".xlsx", ".xls"]}
                    >
                    {({getRootProps, getInputProps, open}) => (
                        <div {...getRootProps()} className={`dropzone ${this.state.file !== null ? "dropped":""}`}>
                        <input {...getInputProps()} />
                            {this.state.file !== null && this.state.file.name?
                                <p>{this.state.file.name}</p>
                                :
                                <p>{this.props.translate.i18n.MODULES.CLIENTS.IMPORT_PLACE}</p>
                            }
                            

                            {/* <button type="button" onClick={() => open()}>
                            {this.props.translate.i18n.MODULES.CLIENTS.IMPORT_CLIENTS_BUTTON}
                            </button> */}
                        </div>
                    )}
                    </Dropzone>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose} className={'gray-text'}>
                    {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    </Button>
                    <Button onClick={this.handleImport} className={'orange-text'}>
                    {this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/clients/list/import/index.js